import { Button } from '@vds/buttons';
import { Icon } from '@vds/icons';
import { Modal, ModalBody } from '@vds/modals';
import { Body, Title } from '@vds/typography';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { LICENSE_OVERUSE_MODAL_TEXTS } from '../../constants/licensesConstants';
import './LicenseOveruseModal.scss';

const LicenseOveruseModal = ({ isOpen, onNavigate }) => {
    const licenseInfo = useSelector((state) => state.licenseReducer.licenses);
    const licenseCounts = useMemo(() => {
        if (!licenseInfo || !Array.isArray(licenseInfo)) {
            return { paid: 0, used: 0 };
        }
        return licenseInfo
            .filter((lic) => lic.state === 'active')
            .reduce(
                (acc, lic) => {
                    acc.paid += lic.licenses || 0;
                    acc.used += lic.usedlicenses || 0;
                    return acc;
                },
                { paid: 0, used: 0 }
            );
    }, [licenseInfo]);

    return (
        <>
            <Modal
                opened={isOpen}
                hideCloseButton={true}
                disableOutsideClick={true}
                className="licenseOveruseModal"
            >
                <ModalBody>
                    <Icon name="warning-solid" color="#D43315" size="large" />

                    <Title
                        size="large"
                        bold
                        primitive="h2"
                        className="modalTitle leftAlign"
                    >
                        {LICENSE_OVERUSE_MODAL_TEXTS.LICENSE_LIMIT_EXCEEDED_TITLE}
                    </Title>

                    <div className="warningBox">
                        <Icon name="warning-solid" color="#D43315" size="medium" />
                        <Body size="small" primitive="p" style={{ margin: 0 }}>
                            <b>{LICENSE_OVERUSE_MODAL_TEXTS.EXCEEDED_LIMIT_HEADING}</b>
                            <br />
                            {LICENSE_OVERUSE_MODAL_TEXTS.EXCEEDED_LIMIT_BODY(licenseCounts.used, licenseCounts.paid)}
                        </Body>
                    </div>

                    <Body size="medium" primitive="p" className="leftAlign">
                        {LICENSE_OVERUSE_MODAL_TEXTS.CHARGE_WARNING}
                    </Body>

                    <div className="buttonContainer">
                        <Button
                            onClick={onNavigate}
                            use="primary"
                            className="manageLicensesButton"
                        >
                            Manage licenses
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default LicenseOveruseModal;